jQuery(document).ready(function ($) {
  if (typeof pageprocessos !== 'undefined') {
    // code here

    // Get references to the "Todas" checkbox and all the other checkboxes
    const todasCheckbox = document.querySelector('input[name="filtro"][data-filtro="all"]');
    const otherCheckboxes = document.querySelectorAll('input[name="filtro"]:not([data-filtro="all"])');
    todasCheckbox.addEventListener("click", updateTodasCheckbox);
    // Add event listeners to all the checkboxes
    for (let i = 0; i < otherCheckboxes.length; i++) {
      otherCheckboxes[i].addEventListener("click", updateTodasCheckbox);
    }

// Function to update the state of the "Todas" checkbox based on the state of the other checkboxes
    function updateTodasCheckbox() {
      if (this === todasCheckbox) {
        otherCheckboxes.forEach((checkbox) => {
          checkbox.checked = todasCheckbox.checked;
        });
      } else {
        let allSelected = true;
        let noneSelected = true; // Add a variable to track if no checkbox is selected
        for (let i = 0; i < otherCheckboxes.length; i++) {
          if (!otherCheckboxes[i].checked) {
            allSelected = false;
          } else {
            noneSelected = false; // If any checkbox is selected, set noneSelected to false
          }
        }
        if (noneSelected) { // If no checkbox is selected, check todasCheckbox
          todasCheckbox.checked = false;
          todasCheckbox.disabled = false;
        } else { // Otherwise, check todasCheckbox only if all other checkboxes are selected
          todasCheckbox.disabled = false;
          todasCheckbox.checked = false;
        }
        if (allSelected) {
          todasCheckbox.checked = true;
        }
      }
    }


// Initialize the state of the "Todas" checkbox when the page loads
    updateTodasCheckbox();

    const checkboxes = document.querySelectorAll('.checkbox__field');

    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        filterCourses();
      });
    });
    function filterCourses() {
      var allcheckboxesfalse = false;
      const ads =document.querySelectorAll('div.curso-info.ad')
      // Get the selected checkboxes
      const selectedFilters = [];
      checkboxes.forEach(checkbox => {

        if (checkbox.checked) {
          allcheckboxesfalse = true
          selectedFilters.push(checkbox.getAttribute('data-filtro'));
        }
        if (allcheckboxesfalse === false){

        }
      });

      // Hide all courses
      const courses = document.querySelectorAll('.curso-info:not(.ad)');
       listofAds = []
      ads.forEach(function (ad){
        ad.remove();
      })
      courses.forEach(course => {
        course.style.display = 'none';
      });

      // Show courses that match the selected filters
      listofAds = []

      selectedFilters.forEach(filter => {
        const coursesToShow = document.querySelectorAll(`.curso-info.${filter}`);
        coursesToShow.forEach(course => {
          sizeCourses ++;
          course.style.display = 'block';
          if( sizeCourses % 3 ===0) {

            generateAd(course);
          }
        });
      });
      sizeCourses = 0;
    }
    //remove bottom border from elements, since graduacao is placing it with force.
    const elements = document.querySelectorAll('div.curso-info__cab.ad');
    for (let i = 0; i < elements.length; i++) {
      elements[i].style.border = '0 solid rgba(0, 0, 0, 0)';

    } const ads =document.querySelectorAll('div.curso-info.ad')
    for (let i = 0; i < ads.length; i++) {
      ads[i].style.height = '194px';
    }

    const  lista = document.querySelector('.lista-cursos');

    todasCheckbox.click();
    todasCheckbox.click();
    //end of code
  }
});
